import { addMessageCurry } from '../utils/api'
import { uploadCsvAPI } from '../api/assets'

export const uploadCsv = (file) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(uploadCsvAPI(file), dispatch).then((csv) => {
        resolve(csv)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/assets.js